import { useState } from "react";

import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import { useDisclosure } from "../../../../hooks";
import { CompanyResultsTableRow } from "../CompanyResultsTableRow";
import { SendJoinRequestDialog } from "../SendJoinRequestDialog";

import type { CompanyBasicDetails } from "components/CompanySetup/types";

interface Props {
  companies: CompanyBasicDetails[];
  searchBegun: boolean;
  onJoinRequestSent: () => void;
  previouslyRejectedCompanyIds: number[];
}

function CompanyResultsNotFoundRow() {
  return (
    <TableRow key="no-results-1">
      <TableCell component="th" scope="row">
        <Stack justifyContent="center">
          <Box textAlign="center">
            <p>No results found</p>
          </Box>
        </Stack>
      </TableCell>
    </TableRow>
  );
}

export function CompanyResultsTable(props: Props) {
  const {
    companies,
    searchBegun,
    onJoinRequestSent,
    previouslyRejectedCompanyIds,
  } = props;
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [selectedCompany, setSelectedCompany] =
    useState<CompanyBasicDetails | null>(null);

  const handleSendJoinRequest = (chosenCompany: CompanyBasicDetails): void => {
    setSelectedCompany(chosenCompany);
    onOpen();
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {companies.length > 0 || !searchBegun ? (
              companies.map((company) => (
                <CompanyResultsTableRow
                  key={company.name}
                  company={company}
                  onCompanySelected={handleSendJoinRequest}
                />
              ))
            ) : (
              <CompanyResultsNotFoundRow />
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedCompany != null && isOpen && (
        <SendJoinRequestDialog
          company={selectedCompany}
          isOpen={isOpen}
          onClose={onClose}
          onJoinRequestSent={onJoinRequestSent}
          isResubmissionAfterRejection={previouslyRejectedCompanyIds.includes(
            selectedCompany.id,
          )}
        />
      )}
    </>
  );
}
